<dx-popup
  [width]="550"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'COMPLETE-TRAINING.CREATE-NEW-PROFILE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [(visible)]="showModal"
  [showCloseButton]="false"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'"> 
    <dx-form
      #form
      labelMode="floating"
      [showColonAfterLabel]="false"
      [formData]="profileForm"
    >
      <dxi-item itemType="group" [colCount]="1">
        <dxi-item dataField="firstName">
          <dxo-label
            [text]="'COMMON.FIELDS.FIRST-NAME' | translate"
          ></dxo-label>
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.FIRST-NAME-REQUIRED' | translate"
          ></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="lastName">
          <dxo-label
            [text]="'COMMON.FIELDS.LAST-NAME' | translate"
          ></dxo-label>
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.LAST-NAME-REQUIRED' | translate"
          ></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          dataField="email"
        >
          <dxo-label
            [text]="'COMMON.FIELDS.EMAIL' | translate"
          ></dxo-label>
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.EMAIL-REQUIRED' | translate"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="email"
            [message]="'VALIDATIONS.EMAIL-INVALID' | translate"
          >
          </dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="locationId">
          <div *dxTemplate>
            <dx-drop-down-box
              #locationDropDown
              [(value)]="profileForm.locationId"
              [inputAttr]="{ 'aria-label': 'Owner' }"
              valueExpr="id"
              displayExpr="name"
              [label]="
                ('COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate) +
                ' *'
              "
              [dataSource]="locations"
              labelMode="floating"
              stylingMode="outlined"
              [showClearButton]="true"
              (onValueChanged)="locationDropDown.instance.close()"
            >
              >
              <dx-validator validationGroup="customFields">
                <dxi-validation-rule
                  type="required"
                  message="Location is required"
                ></dxi-validation-rule>
              </dx-validator>
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [searchEnabled]="true"
                  [dataSource]="locations"
                  keyExpr="id"
                  dataStructure="plain"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  (onItemClick)="onLocationSelected($event)"
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>
        <dxi-item
          [editorOptions]="rolesOptions"
          dataField="roleId"
          editorType="dxSelectBox"
        >
          <dxo-label
            [text]="'COMMON.FIELDS.ROLE' | translate"
          ></dxo-label>
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.ROLE-REQUIRED' | translate"
          ></dxi-validation-rule>
        </dxi-item>
        <dxi-item>
          <dxo-label
            [text]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
          ></dxo-label>
          <div *dxTemplate>
            <dx-drop-down-box
              [(value)]="profileForm.trainingGroupIds"
              [inputAttr]="{ 'aria-label': 'Owner' }"
              valueExpr="id"
              displayExpr="name"
              [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
              [dataSource]="trainingGroups"
              labelMode="floating"
              stylingMode="outlined"
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [searchEnabled]="true"
                  [dataSource]="trainingGroups"
                  dataStructure="plain"
                  keyExpr="id"
                  selectionMode="multiple"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onTrainingGroupSelected($event)
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>
        <dxi-item>
          <dxo-label
            [text]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
          ></dxo-label>
          <div *dxTemplate>
            <dx-drop-down-box
              [(value)]="profileForm.learningPathIds"
              [inputAttr]="{ 'aria-label': 'Owner' }"
              valueExpr="id"
              displayExpr="name"
              [label]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
              [dataSource]="learningPaths"
              labelMode="floating"
              stylingMode="outlined"
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [searchEnabled]="true"
                  [dataSource]="learningPaths"
                  dataStructure="plain"
                  keyExpr="id"
                  selectionMode="multiple"
                  showCheckBoxesMode="normal"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  [selectByClick]="true"
                  (onItemSelectionChanged)="
                    onLearningPathSelected($event)
                  "
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
        </dxi-item>
      </dxi-item>
    </dx-form>
  </div>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      stylingMode: 'contained',
      type: 'danger',
      text: 'COMMON.CANCEL' | translate,
      onClick: onCancelClick
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      type: 'normal',
      text: 'COMMON.SAVE' | translate,
      onClick: onSubmitClick,
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>